import { signal } from '@angular/core';

import { environment } from 'src/environments/environment';

import { parseRoughagePlusEnvironment } from './shared/utils/parse-environment';

declare global {
  var CONFIG_BUILD_ID: string | undefined;
}

export const loadedConfig = signal(environment);

export const setupRuntimeConfig = (async () => {
  try {
    const buildId = globalThis.CONFIG_BUILD_ID;
    const configUrl = buildId
      ? `/assets/config.json?v=${buildId}`
      : '/assets/config.json';
    const response = await globalThis.fetch(configUrl);
    if (response.ok) {
      const config = await response.json();
      if (Object.keys(config).length > 0) {
        loadedConfig.set({
          ...environment,
          ...parseRoughagePlusEnvironment(config),
        });
      } else {
        console.warn(
          'Runtime config.json is empty, using default environment settings.',
        );
      }
    } else {
      console.warn(
        'No runtime configuration found, using default environment settings.',
      );
    }
  } catch (e) {
    console.warn('Failed to load runtime environment variables', e);
  }
})();
